import {
  Component,
  OnInit,
  TemplateRef,
  ChangeDetectorRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { MasterService } from "../services/master-service";
import { CommonHelper } from "../../../helper/helper.component";
import { CommonConstants } from "../../../shared/constants";
import { NgxSpinnerService } from "ngx-spinner";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { finalize, map } from "rxjs/operators";
import { element } from "@angular/core/src/render3";
import { validateConfig } from "@angular/router/src/config";

@Component({
  selector: "app-role",
  templateUrl: "./role.component.html",
  styleUrls: ["./role.component.scss"],
  providers: [MasterService, CommonHelper],
})
export class RoleComponent implements OnInit {
  modalRef: BsModalRef;
  selectedState: any;
  statesData: any;
  rolesData: any;
  rolData: any;
  isStateExists: boolean;
  submitted: boolean;
  selectedStateEvent: any;
  RoleFormNewData: any;
  addRoleForm: FormGroup;
  editRoleForm: FormGroup;
  dataTable: any;
  actionsData: any;
  stateName: String;
  language: any = "en";

  levelData: { id: string; name: string }[];
  selectlevelId: number;
  selecteditlevelId: number;
  activeStates: any;

  constructor(
    private modalService: BsModalService,
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private commonHelper: CommonHelper,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.language = localStorage.getItem("language");
    this.getActiveState();
    this.getActions();
    this.getRoles(this.language);
    this.getLevels();
  }
  /*validation rules*/
  validatorRule() {
    this.addRoleForm = this.fb.group({
      addRoleName: [
        "",
        [
          Validators.required,
          Validators.maxLength(14),
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]*$/),
        ],
      ],
      addRoleDescription: [
        "",
        [
          Validators.maxLength(150),
          Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/),
        ],
      ],
      addRoleActions: [[this.actionsData[0]], [Validators.required]],
      addRoleStatus: [true, Validators.required],
      addUserLevels: [this.levelData[0], [Validators.required]],
      addRoleState: [],
    });
    this.selectlevelId = Number(this.levelData[0].id);
  }
  levelChange() {
    this.selectlevelId = this.addRoleForm.value.addUserLevels.id;
    if (this.selectlevelId == 3) {
      this.addRoleForm.controls["addRoleState"].setValidators([
        Validators.required,
      ]);
    } else {
      this.addRoleForm.controls["addRoleState"].clearValidators();
      this.addRoleForm.controls["addRoleState"].updateValueAndValidity();
    }
  }

  editLevelChange() {
    this.selecteditlevelId = this.editRoleForm.value.editLevelName.id;
    if (this.selecteditlevelId == 3) {
      this.editRoleForm.controls["editRoleState"].setValidators([
        Validators.required,
      ]);
      this.editRoleForm.controls["editRoleState"].setValue({
        id: this.editRoleForm.value.editRoleState.stateId,
        name: this.editRoleForm.value.editRoleState.stateName,
      });
    } else {
      this.editRoleForm.controls["editRoleState"].clearValidators();
      this.editRoleForm.controls["editRoleState"].updateValueAndValidity();
    }
  }
  get addRoleF() {
    return this.addRoleForm.controls;
  }
  get editRoleF() {
    return this.editRoleForm.controls;
  }

  /**
   *
   * @param template
   */
  addRoleModal(template: TemplateRef<any>) {
    this.submitted = false;
    this.modalRef = this.modalService.show(template, { backdrop: "static" });
    this.validatorRule();
  }

  /*get Actions*/
  getActions() {
    try {
      this.spinner.show();
      this.masterService.getAll("actions").subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            response.data.map((item) => {
              item.gender = "Select All";
            });
            this.actionsData = response.data;
            this.reploatingDataTable();
            this.chRef.detectChanges();
            const table: any = $("table");
            this.dataTable = table.DataTable().draw();
          } else {
            this.actionsData = [];
            this.commonHelper.toasterMessageError(
              CommonConstants.statesMessage
            );
            // this.spinner.hide();
            this.reploatingDataTable();
            this.chRef.detectChanges();
            const table: any = $("table");
            this.dataTable = table.DataTable().draw();
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }
  /* get levels */
  getLevels() {
    this.spinner.show();
    this.masterService.getAll("active_levels").subscribe((response: any) => {
      if (response.status == 200) {
        if (response.data.levels.length > 0) {
          this.levelData = response.data.levels.map((x) => {
            return {
              id: x.levelId,
              name: x.name,
            };
          });
        } else {
          this.levelData = [];
          this.commonHelper.toasterMessageError(
            CommonConstants.levelsNotAvailable
          );
        }
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    });
  }

  getActiveState() {
    this.spinner.show();
    this.masterService.getAll("active_states").subscribe((response: any) => {
      if (response.status == 200) {
        if (response.data.length > 0) {
          this.activeStates = response.data.map((x) => {
            return {
              id: x.id,
              name: x.name,
            };
          });
        } else {
          this.activeStates = [];
          this.commonHelper.toasterMessageError(
            CommonConstants.statesNotAvailable
          );
        }
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    });
  }
  onStateChange(event) {
    if (event) {
      // this.getRoles(event.id);
    }
  }
  /* Adding users */
  addRoles() {
    try {
      this.submitted = true;
      if (this.addRoleForm.invalid) {
        return;
      }
      let apiValues = this.addRoleForm.value,
        status = apiValues.addRoleStatus ? "active" : "inactive",
        data = {
          name: apiValues.addRoleName,
          description: apiValues.addRoleDescription,
          features: apiValues.addRoleActions.map((x) => x.id),
          status: status,
          levelId: apiValues.addUserLevels.id,
          stateId: apiValues.addRoleState ? apiValues.addRoleState.id : null,
        };

      this.masterService.postData("roles", data).subscribe(
        (response: any) => {
          if (response.status == 201) {
            this.commonHelper.toasterMessage(response.message);
            this.modalRef.hide();
            this.spinner.hide();
            this.getRoles(this.language);
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        },
        (err) => {
          this.spinner.hide();
        }
      );
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }
  languageChange(event: any) {
    this.language = event;

    if (this.language == "hn" || this.language == "en") {
      this.getRoles(this.language);
    }
  }
  /*get states*/
  getRoles(language: any) {
    try {
      this.masterService.getRole("roles").subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.rolesData = response.data;
            this.reploatingDataTable();
            this.chRef.detectChanges();
            const table: any = $("table");
            if (language == "en") {
              this.dataTable = table
                .DataTable({
                  language: {
                    emptyTable: "No data available in table",
                    info: "Showing _START_ to _END_ of _TOTAL_ entries",
                    infoEmpty: "Showing 0 to 0 of 0 entries",
                    infoFiltered: "(filtered from _MAX_ total entries)",
                    lengthMenu: "Show _MENU_ entries",
                    loadingRecords: "Loading...",
                    processing: "Processing...",
                    search: "Search:",
                    zeroRecords: "No matching records found",
                    paginate: {
                      first: "First",
                      last: "Last",
                      next: "Next",
                      previous: "Previous",
                    },
                    aria: {
                      sortAscending: ": activate to sort column ascending",
                      sortDescending: ": activate to sort column descending",
                    },
                  },
                })
                .draw();
            } else {
              this.dataTable = table.DataTable({
                language: {
                  emptyTable: "तालिका में कोई डेटा उपलब्ध नहीं है",
                  info: "कुल _TOTAL_ एंट्रीज़ में से _START_ से _END_ तक दिखा रहे हैं",
                  infoEmpty: "कुल 0 एंट्रीज़ में से 0 से 0 तक दिखा रहे हैं",
                  infoFiltered: "(_MAX_ एंट्रीज़ से फ़िल्टर किए गए)",
                  lengthMenu: "_MENU_ एंट्रीज़ दिखाएं",
                  loadingRecords: "लोड हो रहा है...",
                  processing: "प्रसंस्करण...",
                  search: "खोजें:",
                  zeroRecords: "कोई मिलान नहीं मिला",
                  paginate: {
                    first: "पहला",
                    last: "अंतिम",
                    next: "अगला",
                    previous: "पिछला",
                  },
                  aria: {
                    sortAscending:
                      ": आरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें",
                    sortDescending:
                      ": अवरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें",
                  },
                },
              });
            }
          } else {
            this.rolesData = [];
            this.reploatingDataTable();
            this.chRef.detectChanges();
            const table: any = $("table");
            this.dataTable = table.DataTable().draw();

            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
          this.commonHelper.toasterMessageError(
            CommonConstants.validationMessage
          );
        }
      });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  /**
   * updating the status of the level
   * @param rolevalues
   */
  rolesStatus(rolevalues: any, status) {
    try {
      this.spinner.show();
      let data = {
        status: status === "active" ? "inactive" : "active",
      };
      this.masterService
        .putData("update_role_status/", rolevalues, data)
        .pipe(finalize(this.spinner.hide))
        .subscribe((response: any) => {
          if (response.status == 200) {
            this.commonHelper.toasterMessage(response.message);
            this.getRoles(this.language);
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        });
    } catch (exc) {
      this.spinner.hide();
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }
  openEditModal(formData: any, template: TemplateRef<any>) {
    this.rolData = formData;

    this.modalRef = this.modalService.show(template, { backdrop: "static" });
    let status = formData.status === "active" ? true : false;
    let featureArray = formData.features.map((x) => {
      return {
        id: x.actionId,
        name: x.actionName,
      };
    });
    this.editRoleForm = this.fb.group({
      editLevelName: [formData.level, [Validators.required]],
      editRoleName: [
        formData.name,
        [
          Validators.required,
          Validators.maxLength(14),
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]*$/),
        ],
      ],
      editRoleDescription: [
        formData.description,
        [
          Validators.maxLength(150),
          Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/),
        ],
      ],
      editRoleActions: [featureArray, [Validators.required]],
      editRoleStatus: [status, Validators.required],
      editRoleState: [formData.state],
    });

    this.editLevelChange();
  }

  /**
   * level update*/
  editRoles(template: TemplateRef<any>) {
    try {
      this.submitted = true;
      if (this.editRoleForm.invalid) {
        return;
      }

      let apiData = this.editRoleForm.value,
        status = apiData.editRoleStatus ? "active" : "inactive",
        data = {
          name: apiData.editRoleName,
          status: status,
          description: apiData.editRoleDescription,
          levelId: apiData.editLevelName.id,
          features: apiData.editRoleActions.map((x) => x.id),
          stateId: apiData.editRoleState ? apiData.editRoleState.id : null,
        };
      this.masterService
        .putData("roles/", this.rolData.id, data)
        .subscribe((response: any) => {
          if (response.status == 200) {
            this.commonHelper.toasterMessage(response.message);
            this.modalRef.hide();
            this.getRoles(this.language);
            this.selectedState = apiData.editRoleState;
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }
  deleteRoleModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable1").DataTable();
    table.destroy();
  }
}
